import filesize from 'filesize';
import stringUtils from '@/shared/utils/string-utils';
import fileModel from './file-model';

export default {
  validate(file, files, max, size, extensions) {
    if (max && files.length > max) {
      throw new Error(`Limit of files is ${max}`);
    }

    if (size) {
      if (file.size > size) {
        throw new Error(`Size limit is ${filesize(size)}`);
      }
    }

    if (extensions && extensions.length) {
      if (
        !extensions.includes(fileModel.extension(file.name))
      ) {
        throw new Error(
          `This field allows only ${stringUtils.literalJoin(
            extensions,
            ', ',
            ' or '
          )}`
        );
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/shared/file/file-validator.js